







































































import { Component, Mixins } from "vue-property-decorator";
import ConfirmationMixin from "../../mixins/http/ConfirmationMixin";
import DisplayErrors from "@/components/DisplayErrors.vue";
import RequestData from "@/store/types/RequestData";
import { RegisterHttp } from "@/utils/Decorators";
import { showToast } from "@/utils/Toast";
import store from "@/store";

@Component({ components: { DisplayErrors } })
export default class Confirmation extends Mixins(ConfirmationMixin) {
  private isValid = false;
  private password = "";
  private repeatPassword = "";

  @RegisterHttp("confirmation") http: RequestData;

  get confirmationToken() {
    return this.$route.query.confirmation_token as string;
  }

  get error() {
    return (
      this.repeatPassword.length > 0 &&
      this.password.length > 0 &&
      this.password !== this.repeatPassword
    );
  }

  created() {
    this.validateToken(this.confirmationToken).then(
      (resp) => {
        this.isValid = true;
      },
      (err) => {
        showToast(`An error occurred while activating the user`, {
          type: "error",
        });
        this.isValid = false;
      }
    );
  }

  login(credentials: { email: string; password: string }) {
    store.dispatch("login", credentials).then(
      (user) => {
        window.location.reload();
      },
      (err) => {}
    );
  }

  submit() {
    this.confirmWithPassword(this.confirmationToken, this.password).then(
      (resp) => {
        const credentials = { email: resp.email, password: this.password };
        this.login(credentials);
      },
      (err) => {
        showToast(`An error occurred ${err}`, { type: "error" });
      }
    );
  }
}
